import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../../Command";
import { ServiceResponseData } from "../../ServiceResponseData";
import { SetInstallationsPackagesReqData } from "./SetInstallationsPackagesReqData";

const ENDPOINT = "/device_update/associated_package";

export class SetInstallationsPackagesCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "patch";

    payload: SetInstallationsPackagesReqData;

    constructor(payload: SetInstallationsPackagesReqData) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<ServiceResponseData> {
        var res = await this.executeCommand(this.payload);
        return new ServiceResponseData(res);
    }
}
